// LIST
export const FETCH_RESIDENT = "app/RESIDENT/FETCH_RESIDENT";
export const FETCH_RESIDENT_SUCCESS = "app/RESIDENT/FETCH_RESIDENT_SUCCESS";
export const FETCH_RESIDENT_FAILURE = "app/RESIDENT/FETCH_RESIDENT_FAILURE";
// GET VIEW DATA
export const GET_VIEW_DATA = "app/RESIDENT/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/RESIDENT/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/RESIDENT/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_RESIDENT = "app/RESIDENT/ADD_RESIDENT";
export const ADD_RESIDENT_SUCCESS = "app/RESIDENT/ADD_RESIDENT_SUCCESS";
export const ADD_RESIDENT_FAILURE = "app/RESIDENT/ADD_RESIDENT_FAILURE";
// EDIT
export const EDIT_RESIDENT = "app/RESIDENT/EDIT_RESIDENT";
export const EDIT_RESIDENT_SUCCESS = "app/RESIDENT/EDIT_RESIDENT_SUCCESS";
export const EDIT_RESIDENT_FAILURE = "app/RESIDENT/EDIT_RESIDENT_FAILURE";
// DELETE
export const DELETE_RESIDENT = "app/RESIDENT/DELETE_RESIDENT";
export const DELETE_RESIDENT_SUCCESS = "app/RESIDENT/DELETE_RESIDENT_SUCCESS";
export const DELETE_RESIDENT_FAILURE = "app/RESIDENT/DELETE_RESIDENT_FAILURE";

export const TOGGLE_RESIDENT_MODAL = "app/RESIDENT/TOGGLE_RESIDENT_MODAL";
export const TOGGLE_BELONGINGS_MODAL = "app/RESIDENT/TOGGLE_BELONGINGS_MODAL";

export const UPDATE_PROFILE = "app/RESIDENT/UPDATE_PROFILE";
export const UPDATE_PROFILE_SUCCESS = "app/RESIDENT/UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_FAILURE = "app/RESIDENT/UPDATE_PROFILE_FAILURE";

// Belongings
export const FETCH_BELONGINGS = "app/RESIDENT/FETCH_BELONGINGS";
export const FETCH_BELONGINGS_SUCCESS = "app/RESIDENT/FETCH_BELONGINGS_SUCCESS";
export const FETCH_BELONGINGS_FAILURE = "app/RESIDENT/FETCH_BELONGINGS_FAILURE";

export const ADD_BELONGING = "app/RESIDENT/ADD_BELONGING";
export const ADD_BELONGING_SUCCESS = "app/RESIDENT/ADD_BELONGING_SUCCESS";
export const ADD_BELONGING_FAILURE = "app/RESIDENT/ADD_BELONGING_FAILURE";

export const DELETE_BELONGING = "app/RESIDENT/DELETE_BELONGING";
export const DELETE_BELONGING_SUCCESS = "app/RESIDENT/DELETE_BELONGING_SUCCESS";
export const DELETE_BELONGING_FAILURE = "app/RESIDENT/DELETE_BELONGING_FAILURE";

export const GET_RESIDENT_DATA = "app/RESIDENT/GET_RESIDENT_DATA";
export const GET_RESIDENT_DATA_SUCCESS =
  "app/RESIDENT/GET_RESIDENT_DATA_SUCCESS";
export const GET_RESIDENT_DATA_FAILURE =
  "app/RESIDENT/GET_RESIDENT_DATA_FAILURE";

export const GET_DOC_STATUS = "app/RESIDENT/GET_DOC_STATUS";
export const GET_DOC_STATUS_SUCCESS = "app/RESIDENT/GET_DOC_STATUS_SUCCESS";
export const GET_DOC_STATUS_FAILURE = "app/RESIDENT/GET_DOC_STATUS_FAILURE";

export const GET_TIMELINE = "app/RESIDENT/GET_TIMELINE";
export const GET_TIMELINE_SUCCESS = "app/RESIDENT/GET_TIMELINE_SUCCESS";
export const GET_TIMELINE_FAILURE = "app/RESIDENT/GET_TIMELINE_FAILURE";

export const LOAD_MORE_TIMELINE = "app/RESIDENT/LOAD_MORE_TIMELINE";
export const LOAD_MORE_TIMELINE_SUCCESS =
  "app/RESIDENT/LOAD_MORE_TIMELINE_SUCCESS";
export const LOAD_MORE_TIMELINE_FAILURE =
  "app/RESIDENT/LOAD_MORE_TIMELINE_FAILURE";

export const GET_MY_ASSESSMENTS = "app/RESIDENT/GET_MY_ASSESSMENTS";
export const GET_MY_ASSESSMENTS_SUCCESS =
  "app/RESIDENT/GET_MY_ASSESSMENTS_SUCCESS";
export const GET_MY_ASSESSMENTS_FAILURE =
  "app/RESIDENT/GET_MY_ASSESSMENTS_FAILURE";

export const GET_OVERVIEW = "app/RESIDENT/GET_OVERVIEW";
export const GET_OVERVIEW_SUCCESS = "app/RESIDENT/GET_OVERVIEW_SUCCESS";
export const GET_OVERVIEW_FAILURE = "app/RESIDENT/GET_OVERVIEW_FAILURE";

export const CONVERT_RESIDENT = "app/RESIDENT/CONVERT_RESIDENT";
export const CONVERT_RESIDENT_SUCCESS = "app/RESIDENT/CONVERT_RESIDENT_SUCCESS";
export const CONVERT_RESIDENT_FAILURE = "app/RESIDENT/CONVERT_RESIDENT_FAILURE";

export const UPDATE_RESIDENT_STATUS = "app/RESIDENT/UPDATE_RESIDENT_STATUS";
export const UPDATE_RESIDENT_STATUS_SUCCESS =
  "app/RESIDENT/UPDATE_RESIDENT_STATUS_SUCCESS";
export const UPDATE_RESIDENT_STATUS_FAILURE =
  "app/RESIDENT/UPDATE_RESIDENT_STATUS_FAILURE";

export const GET_TIMELINE_INFO = "app/RESIDENT/GET_TIMELINE_INFO";
export const GET_TIMELINE_INFO_SUCCESS =
  "app/RESIDENT/GET_TIMELINE_INFO_SUCCESS";
export const GET_TIMELINE_INFO_FAILURE =
  "app/RESIDENT/GET_TIMELINE_INFO_FAILURE";

export const GET_PRE_ASSESSMENT = "app/RESIDENT/GET_PRE_ASSESSMENT";
export const GET_PRE_ASSESSMENT_SUCCESS =
  "app/RESIDENT/GET_PRE_ASSESSMENT_SUCCESS";
export const GET_PRE_ASSESSMENT_FAILURE =
  "app/RESIDENT/GET_PRE_ASSESSMENT_FAILURE";

export const GET_ASSESSMENT_FORM = "app/RESIDENT/GET_ASSESSMENT_FORM";
export const GET_ASSESSMENT_FORM_SUCCESS =
  "app/RESIDENT/GET_ASSESSMENT_FORM_SUCCESS";
export const GET_ASSESSMENT_FORM_FAILURE =
  "app/RESIDENT/GET_ASSESSMENT_FORM_FAILURE";

export const GET_DOC_QR_CODE = "app/RESIDENT/GET_DOC_QR_CODE";
export const GET_DOC_QR_CODE_SUCCESS = "app/RESIDENT/GET_DOC_QR_CODE_SUCCESS";
export const GET_DOC_QR_CODE_FAILURE = "app/RESIDENT/GET_DOC_QR_CODE_FAILURE";

export const ADD_PRE_ASSESSMENT = "app/RESIDENT/ADD_PRE_ASSESSMENT";
export const ADD_PRE_ASSESSMENT_SUCCESS =
  "app/RESIDENT/ADD_PRE_ASSESSMENT_SUCCESS";
export const ADD_PRE_ASSESSMENT_FAILURE =
  "app/RESIDENT/ADD_PRE_ASSESSMENT_FAILURE";

export const EDIT_PRE_ASSESSMENT = "app/RESIDENT/EDIT_PRE_ASSESSMENT";
export const EDIT_PRE_ASSESSMENT_SUCCESS =
  "app/RESIDENT/EDIT_PRE_ASSESSMENT_SUCCESS";
export const EDIT_PRE_ASSESSMENT_FAILURE =
  "app/RESIDENT/EDIT_PRE_ASSESSMENT_FAILURE";

// AI alerts review
export const FETCH_RESIDENT_ALERTS_REVIEW =
  "app/RESIDENT/FETCH_RESIDENT_ALERTS_REVIEW";
export const FETCH_RESIDENT_ALERTS_REVIEW_SUCCESS =
  "app/RESIDENT/FETCH_RESIDENT_ALERTS_REVIEW_SUCCESS";
export const FETCH_RESIDENT_ALERTS_REVIEW_FAILURE =
  "app/RESIDENT/FETCH_RESIDENT_ALERTS_REVIEW_FAILURE";

// Scheduled Report
export const FETCH_SCHEDULED_REPORT = "app/RESIDENT/FETCH_SCHEDULED_REPORT";
export const FETCH_SCHEDULED_REPORT_SUCCESS =
  "app/RESIDENT/FETCH_SCHEDULED_REPORT_SUCCESS";
export const FETCH_SCHEDULED_REPORT_FAILURE =
  "app/RESIDENT/FETCH_SCHEDULED_REPORT_FAILURE";

// Hospital report PDF export
export const EXPORT_HOSPITAL_REPORT = "app/RESIDENT/EXPORT_HOSPITAL_REPORT";
export const EXPORT_HOSPITAL_REPORT_SUCCESS =
  "app/RESIDENT/EXPORT_HOSPITAL_REPORT_SUCCESS";
export const EXPORT_HOSPITAL_REPORT_FAILURE =
  "app/RESIDENT/EXPORT_HOSPITAL_REPORT_FAILURE";
